import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type ScaleCamera = {
  id: string;
  name: string;
  sidecarId: string;
  streamUrl: string | null;
  streamProfile: string | null;
  sidecar: ScaleSidecar | null;
};

export type ScaleSidecar = {
  id: string;
  name: string;
  peerId: string | null;
  multiaddrs: string[];
  status: string;
};

export type Scale = {
  id: string;
  name: string;
  scaleFormatType: string;
  unitOfMeasurement: string;
  status: string;
  online: boolean;
  camera: ScaleCamera | null;
  sidecar: ScaleSidecar | null;
};

export const scalesQueryAtom = createQueryAtomFactory(
  'shared.scales',
  (params: { facilityId?: string }) => ({
    scales: {
      __args: {
        filter: {
          ...(params.facilityId ? { facilityId: params.facilityId } : {}),
        },
        pagination: {
          limit: 100,
          offset: 0,
        },
      },
      entries: {
        id: true,
        name: true,
        scaleFormatType: true,
        unitOfMeasurement: true,
        status: true,
        online: true,
        cameraId: true,
        camera: {
          id: true,
          name: true,
          sidecarId: true,
          streamUrl: true,
          streamProfile: true,
          sidecar: {
            id: true,
            name: true,
            peerId: true,
            multiaddrs: true,
            status: true,
          },
        },
        sidecar: {
          id: true,
          name: true,
          peerId: true,
          multiaddrs: true,
          status: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): { scales: Scale[] } => {
      if (!data?.scales?.entries) {
        return { scales: [] };
      }

      return {
        scales: data.scales.entries.map((entry) => ({
          id: entry.id,
          name: entry.name,
          scaleFormatType: entry.scaleFormatType ?? '',
          unitOfMeasurement: entry.unitOfMeasurement ?? '',
          status: entry.status ?? '',
          online: entry.online ?? false,
          camera: entry.camera
            ? {
                id: entry.camera.id,
                name: entry.camera.name,
                sidecarId: entry.camera.sidecarId,
                streamUrl: entry.camera.streamUrl ?? null,
                streamProfile: entry.camera.streamProfile ?? null,
                sidecar: entry.camera.sidecar
                  ? {
                      id: entry.camera.sidecar.id,
                      name: entry.camera.sidecar.name ?? '',
                      peerId: entry.camera.sidecar.peerId ?? null,
                      multiaddrs: entry.camera.sidecar.multiaddrs ?? [],
                      status: entry.camera.sidecar.status ?? '',
                    }
                  : null,
              }
            : null,
          sidecar: entry.sidecar
            ? {
                id: entry.sidecar.id,
                name: entry.sidecar.name,
                peerId: entry.sidecar.peerId ?? null,
                multiaddrs: entry.sidecar.multiaddrs ?? [],
                status: entry.sidecar.status ?? '',
              }
            : null,
        })),
      };
    },
  },
);
